<template>
  <v-app class="d-flex flex-column">
    <header>
      <!-- Barra de Navegación Escritorio  -->
      <v-app-bar app class="black" v-if="$vuetify.breakpoint.mdAndUp" overflow-y-visible hide-on-scroll
        scroll-target="#scrolling-techniques-4">
        <v-container class="d-flex align-content-center">
          <!-- Logotipo Ticket Shop -->
          <router-link :to="{ path: '/' }" class="logo-new my-auto" title="TicketShop" tag="a">
            <v-img src="/images/logo-dark.svg" max-width="48"> </v-img>
          </router-link>
          <v-spacer></v-spacer>

          <!-- Pasos de Compra -->
          <v-container class="py-0 d-flex align-center justify-center flex-sm-nowrap pr-0" height="100"
            v-if="$vuetify.breakpoint.mdAndUp">
            <v-col cols="10" sm="8">
              <!--//// Step  Mobile ////-->
              <v-stepper dark class="transparent" flat value="3">
                <v-stepper-header class="text-body-2 font-weight-medium">
                  <v-stepper-step step="1" complete>
                    Fecha del evento
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2" complete>
                    Selección de entradas
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3"> Confirmar y pagar </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
          </v-container>

          <v-spacer></v-spacer>
          <!-- Avatar -->
          <v-col class="my-auto flex-grow-0 flex-shrink-1">
            <!-- Login -->
            <router-link width="52" height="52" :to="{ path: '/login' }"
              aria-label="Ir a la página de inicio de sesión">
              <v-btn v-if="!$store.state.user.accessToken" icon x-large v-on="on" class="d-flex d-md-none order-3"
                aria-label="Iniciar sesión">
                <v-avatar class="profile" color="primaryContainer">
                  <v-img src="/images/avatar.svg" alt="Avatar de usuario">
                  </v-img>
                </v-avatar>
              </v-btn>
            </router-link>

            <!-- Usuario Logeado -->
            <v-menu transition="slide-y-transition" bottom left min-width="200px" rounded offset-y
              v-if="$store.state.user.accessToken">
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on">
                  <v-avatar class="profile" color="primaryContainer" size="48">
                    <span class="primary--text text-h5">
                      {{ usuario.nombre.substr(0, 1) }}
                    </span>
                  </v-avatar>
                </v-btn>
              </template>

              <!-- Menu Usuario -->
              <v-card>
                <v-list-item-content class="justify-center">
                  <div class="mx-auto text-center">
                    <span class="onSurface--text text-h4">
                      {{ usuario.nombre }}
                    </span>
                    <p class="text-caption mt-1">
                      {{ usuario.email }}
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <router-link :to="{
                      name: 'perfil',
                    }">
                      <v-btn class="black--text" text rounded>Mi perfil </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'perfil',
                      params: {
                        optPerfil: 3,
                      },
                    }" v-if="usuario.id_rol == 2">
                      <v-btn depressed rounded text> Mis Compras </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'contacto',
                    }">
                      <v-btn depressed rounded text> Soporte </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>
                    <!-- Acceso SuperUsuario -->
                    <router-link :to="{
                      name: 'misEventos',
                    }" v-if="
                      usuario.id_rol == 1 ||
                      usuario.id_rol == 4 ||
                      usuario.id_rol == 7 ||
                      usuario.id_rol == 5
                    ">
                      <v-btn depressed rounded text> Mis Eventos </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'PuntosVentaJefePunto',
                    }" v-if="usuario.id_rol == 7"><v-btn depressed rounded text>Puntos de Venta</v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'pagosParciales',
                    }" v-if="usuario.id_rol == 5">
                      <v-btn depressed rounded text> Pagos parciales </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'eventosAprobacion',
                    }" v-if="usuario.id_rol == 6">
                      <v-btn depressed rounded text>
                        <v-divider class="my-2"></v-divider>
                        Eventos aprobacion
                      </v-btn>
                    </router-link>

                    <v-btn @click.prevent="logout" rounded text>
                      <v-divider class="my-2"></v-divider>

                      Cerrar sesion
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu>
          </v-col>
        </v-container>
      </v-app-bar>

      <!-- Barra Mobile -->
      <nav class="barraNavegacionServicios black pt-2" v-if="$vuetify.breakpoint.smAndDown">
        <div class="atras">
          <v-app-bar-nav-icon x-large>
            <a :href="'/eventos/seleccionpuesto/' + $route.params.evento">
              <v-icon dark x-large class="fill-height onPrimary--text">mdi-arrow-left</v-icon></a>
          </v-app-bar-nav-icon>
        </div>
        <div class="nav-info onPrimary--text">
          <v-col class="ml-2">
            <span class="d-flex text-body-2 font-weight-bold" style="max-width: 250px">
              {{ evento.nombre }}
            </span>
            <span class="d-inline-flex caption text-capitalize mt-0">
              {{ evento.auditorio.nombre.toUpperCase() }}
            </span>
            <span class="text-start caption text-capitalize mt-0">
              {{ formatFecha(evento.fecha_evento) }}
            </span>
          </v-col>
        </div>
        <div class="avatar">
          <!-- Avatar -->
          <v-col class="my-auto flex-grow-0 flex-shrink-1 mr-n4 pr-0">
            <!-- Login -->
            <v-btn v-if="!$store.state.user.accessToken" icon x-large v-on="on" class="d-flex d-md-none order-3">
              <v-avatar class="profile" color="primaryContainer" size="48">
                <router-link :to="{ path: '/login' }">
                  <v-img src="/images/avatar.svg"> </v-img>
                </router-link>
              </v-avatar>
            </v-btn>

            <!-- Usuario Logeado -->
            <v-menu transition="slide-y-transition" bottom left min-width="200px" rounded offset-y
              v-if="$store.state.user.accessToken">
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on">
                  <v-avatar class="profile" color="primaryContainer" size="48">
                    <span class="primary--text text-h5">
                      {{ usuario.nombre.substr(0, 1) }}
                    </span>
                  </v-avatar>
                </v-btn>
              </template>

              <!-- Menu Usuario -->
              <v-card>
                <v-list-item-content class="justify-center">
                  <div class="mx-auto text-center">
                    <span class="onSurface--text text-h4">
                      {{ usuario.nombre }}
                    </span>
                    <p class="text-caption mt-1">
                      {{ usuario.email }}
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <router-link :to="{
                      name: 'perfil',
                    }">
                      <v-btn class="black--text" text rounded>Mi perfil </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'perfil',
                      params: {
                        optPerfil: 3,
                      },
                    }" v-if="usuario.id_rol == 2">
                      <v-btn depressed rounded text> Mis Compras </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>

                    <router-link :to="{
                      name: 'contacto',
                    }">
                      <v-btn depressed rounded text> Soporte </v-btn>
                      <v-divider class="my-2"></v-divider>
                    </router-link>
                    <!-- Acceso SuperUsuario -->
                    <router-link :to="{
                      name: 'misEventos',
                    }" v-if="
                      usuario.id_rol == 1 ||
                      usuario.id_rol == 4 ||
                      usuario.id_rol == 7 ||
                      usuario.id_rol == 5
                    ">
                      <v-btn depressed rounded text> Mis Eventos </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'PuntosVentaJefePunto',
                    }" v-if="usuario.id_rol == 7"><v-btn depressed rounded text>Puntos de Venta</v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'pagosParciales',
                    }" v-if="usuario.id_rol == 5">
                      <v-btn depressed rounded text> Pagos parciales </v-btn>
                    </router-link>
                    <router-link :to="{
                      name: 'eventosAprobacion',
                    }" v-if="usuario.id_rol == 6">
                      <v-btn depressed rounded text>
                        <v-divider class="my-2"></v-divider>
                        Eventos aprobacion
                      </v-btn>
                    </router-link>

                    <v-btn @click.prevent="logout" rounded text>
                      <v-divider class="my-2"></v-divider>

                      Cerrar sesion
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu>
          </v-col>
        </div>

        <div class="paso">
          <v-progress-linear rounded background-color="primaryContainer" color="primary" height="8"
            value="95"></v-progress-linear>
          <v-sheet dark class="d-flex justify-center align-center black pt-2">
            <h6>
              <v-btn color="primary" class="font-weight-bold text-body-2 mr-3" x-small fab>3</v-btn>
              Confirmar y pagar
            </h6>
          </v-sheet>
        </div>
      </nav>
    </header>
    <v-main class="v-main-complete grey lighten-3 ma-0 pb-4 pt-md-8">
      <!-- Resumen de compra -->
      <v-row no-gutters class="onPrimary ma-0 pa-0" v-if="$vuetify.breakpoint.smAndDown">
        <v-container>
          <v-col cols="12">
            <div class="resumen-compra-sticky  rounded-b-lg">
              <v-sheet>

                <div class="col-md-3 col-lg-3 col-sm-3" v-if="evento.seguro == 0 && evento.id_tipo_evento != 8"></div>
                <div>
                  <v-col class="mt-0 pt-0" style="font-family: 'Cabin', sans-serif">
                    <v-divider></v-divider>
                    <v-text class="title font-weight-bold">Resumen de Compra</v-text>

                    <v-simple-table v-if="$store.state.resumenFinalizarCompra" class="body-1 outline--text"
                      style="border-collapse: collapse">
                      <tbody>
                        <tr :key="index" v-for="(product, index) in $store.state
                          .resumenFinalizarCompra.productos">
                          <td style="border: none">
                            <v-text>
                              {{ formatProductName(product.nombre) }}
                            </v-text>
                          </td>
                          <td nowrap class="text-right" style="border: none">
                            <v-text>
                              {{ product.total }}
                            </v-text>
                          </td>
                        </tr>

                        <tr v-if="evento.seguro == 1">
                          <td style="border: none">Subtotal:</td>
                          <td class="text-right" style="border: none">
                            {{ cartsubtotal.toLocaleString() }}
                          </td>
                        </tr>
                        <tr v-if="evento.seguro == 1">
                          <td style="border: none">Reserva reembolsable:</td>
                          <td class="text-right" style="border: none">
                            <v-text>
                              ${{ $store.state.protectionValue.toLocaleString() }}
                            </v-text>
                          </td>
                        </tr>

                        <tr>
                          <td style="
                            border-top: 1px solid;
                            border-bottom: 1px solid;
                            border-color: #cac5cb;
                          ">
                            <v-text class="font-weight-medium onBackground--text">
                              Precio Total:
                            </v-text>
                          </td>
                          <td class="text-right" style="
                            border-top: 1px solid;
                            border-bottom: 1px solid;
                            border-color: #cac5cb;
                          ">
                            <v-text class="onBackground--text subtitle-1">
                              ${{ $store.state.totalValue.toLocaleString() }}
                            </v-text>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <!--      <a class="btn btn-info" style="color: white;  "
                      @click="enviaraEvento()"><v-icon>shopping_cart</v-icon>&nbsp;
                      SEGUIR
                      COMPRANDO</a>

                    &nbsp;&nbsp;
                    <v-chip v-if="evento.venta_linea == 1 && evento.status == 1" @click="clearCantBoleta">
                      <v-icon center color="#907b16">remove_shopping_cart</v-icon>
                      <b>&nbsp;VACIAR CARRITO</b>
                    </v-chip> -->
                  </v-col>
                </div>
                <div class="col-md-3 col-lg-3 col-sm-3" v-if="evento.seguro == 0"></div>

              </v-sheet>



              <!-- Botones de Acciones -->
              <v-row v-if="$vuetify.breakpoint.mdAndUp">
                <v-col cols="12" class="text-center">
                  <v-btn color="primary" height="44px" block rounded
                    v-if="evento.venta_linea == 1 && evento.status == 1" @click="pagar()">
                    Confirmar y pagar
                  </v-btn>
                  <v-btn v-if="evento.venta_linea == 1 && evento.status == 1" @click="clearCantBoleta()" class="mt-3"
                    color="outline" outlined height="44px" block rounded>
                    <v-icon center></v-icon>&nbsp;Cancelar
                  </v-btn>
                </v-col>

                <!-- Terminos y condiciones -->
                <v-col class="p-3 d-flex justify-content-start">
                  <v-text>
                    Al hacer clic en Confirmar y pagar aceptas
                    <router-link target="_blank" v-model="acceptTyC" :to="{ name: 'terminoscondiciones' }">Términos y
                      condiciones</router-link>
                    y
                    <router-link v-model="acceptTD" :to="{ name: 'politicatratamiento' }" target="_blank">Tratamiento de
                      datos personales</router-link>
                  </v-text>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-container>
      </v-row>

      <v-container class="rounded-lg my-auto ">

        <v-row no-gutters class="d-flex">



          <!-- Info Evento -->
          <v-col cols="12" md="6">
            <div class="info-evento-scroll">
              <!-- Card Info Evento y Cantidades -->
              <v-col cols="12" class="mx-0 px-0">
                <v-row class="mx-0 px-0 mt-4">
                  <!-- Escritorio -->
                  <v-col v-if="$vuetify.breakpoint.mdAndUp" class="d-flex justify-content-center">
                    <v-card class="rounded-lg" outlined>
                      <v-row class="d-flex align-content-center justify-content-start">
                        <!-- Imagen -->
                        <v-col cols="6" class="pa-3">
                          <v-img class="rounded-lg" cover :key="index" v-for="(imagen, index) in evento.imagens"
                            v-show="imagen.nombre.includes('miniatura_320')" :src="imagen.url">
                          </v-img>
                        </v-col>
                        <!-- Información -->
                        <v-col cols="5" class="pa-2 d-flex flex-column">
                          <article>
                            <v-text class="d-flex title font-weight-bold text-capitalize">
                              {{ evento.nombre }}
                            </v-text>
                            <v-text class="text-start subtitle-1 text-capitalize mt-0">
                              {{ formatFecha(evento.fecha_evento) }}
                            </v-text>
                            <v-text class="cabin text-start body-1 text-capitalize mt-3">
                              {{ evento.tipoevento.nombre }}
                            </v-text>
                          </article>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Card Mobile -->
                <v-col v-if="$vuetify.breakpoint.smAndDown">
                  <v-card class="rounded-lg" outlined>
                    <v-row class="d-flex align-content-center justify-content-start">
                      <!-- Imagen -->
                      <!--                   <v-col cols="12">
                    <v-img
                      class="rounded-lg"
                      :key="index"
                      v-for="(imagen, index) in evento.imagens"
                      v-show="imagen.nombre.includes('miniatura_320')"
                      :src="imagen.url"
                    >
                    </v-img>
                  </v-col> -->
                      <!-- Información -->
                      <v-col cols="12" class="flex-column ml-4 d-flex">
                        <v-card-subtitle class="cabin text-start text-capitalize overline ma-0 pa-0">
                          {{ evento.tipoevento.nombre }}
                        </v-card-subtitle>
                        <v-card-title class="d-flex title font-weight-bold text-capitalize mx-0 px-0">
                          {{ evento.nombre }}
                        </v-card-title>

                        <v-card-subtitle class="cabin text-start text-capitalize mx-0 px-0">
                          {{ formatFecha(evento.fecha_evento) }}
                        </v-card-subtitle>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <!-- Participantes -->
              <v-col cols="12" v-if="evento.id_tipo_evento == 8">
                
                <Participantes >
                  
                </Participantes>
              </v-col>
                <!-- Reserva Reembolsable -->
                <v-row>
                  <v-col class="ma-0 pa-0" v-if="evento.seguro == 1 || evento.id_tipo_evento == 8">
                    <v-col>
                      <v-card-title class="title font-weight-bold mx-0 px-0" v-if="evento.seguro == 1">Reserva
                        Reembolsable
                      </v-card-title>

                      <PgWidgetLoaded ref="miComponente" :valortotalcompra="valortotalcompra"
                        :numeroboletas="numeropuestoscompra" :fechaevento="evento.fecha_evento"
                        v-if="evento.seguro == 1">
                      </PgWidgetLoaded>




                    </v-col>
                  </v-col>
                </v-row>
                <!-- Metodos de Pago -->
                <!--<v-row>
              <v-col>
                <v-card class="pa-4" flat>
                  <v-radio-group v-model="radioGroup">
                    <v-radio label="Tarjeta de Credito" value="credito">
                      <v-icon>
                        payment
                      </v-icon>
                    </v-radio>
                    <v-col v-if="radioGroup === 'credito'">
                      <v-text-field outlined v-model="creditCardNumber" label="Número de Tarjeta de Crédito" clearable>

                      </v-text-field>
                      <v-text-field outlined v-model="creditCardName" label="Nombre en la Tarjeta" clearable>

                      </v-text-field>
                      <v-row class="d-flex justify-content-between flex-nowrap ">
                        <v-text-field class="mr-2" outlined v-model="creditCardExpiry" label="Fecha de Expiración"
                          clearable>

                        </v-text-field>
                        <v-text-field outlined v-model="cvv" label="CVV" clearable>

                        </v-text-field>




                      </v-row>

                    </v-col>
                    <v-radio label="PSE" value="pse">
                      <v-icon>
                        payment
                      </v-icon>
                    </v-radio>
                    <v-col v-if="radioGroup === 'pse'">
                      <v-text-field outlined v-model="pseAccountNumber" label="Número de Cuenta PSE" clearable>

                      </v-text-field>
                      <v-select outlined v-model="pseBankName" label="Nombre del Banco" clearable>

                      </v-select>
                    </v-col>
                  </v-radio-group>
                </v-card>
              </v-col>
            </v-row>-->


              </v-col>


              
            </div>
          </v-col>


          <!-- Resumen de compra -->
          <v-col cols="12" md="6" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="resumen-compra-sticky onPrimary rounded-b-lg">
              <v-sheet>

                <div class="col-md-3 col-lg-3 col-sm-3" v-if="evento.seguro == 0 && evento.id_tipo_evento != 8"></div>
                <div>
                  <v-col class="mt-0 pt-0" style="font-family: 'Cabin', sans-serif">
                    <v-divider></v-divider>
                    <v-text class="title font-weight-bold">Resumen de Compra</v-text>

                    <v-simple-table v-if="$store.state.resumenFinalizarCompra" class="body-1 outline--text"
                      style="border-collapse: collapse">
                      <tbody>
                        <tr :key="index" v-for="(product, index) in $store.state
                          .resumenFinalizarCompra.productos">
                          <td style="border: none">
                            <v-text>
                              {{ formatProductName(product.nombre) }}
                            </v-text>
                          </td>
                          <td nowrap class="text-right" style="border: none">
                            <v-text>
                              {{ product.total }}
                            </v-text>
                          </td>
                        </tr>

                        <tr v-if="evento.seguro == 1">
                          <td style="border: none">Subtotal:</td>
                          <td class="text-right" style="border: none">
                            {{ cartsubtotal.toLocaleString() }}
                          </td>
                        </tr>
                        <tr v-if="evento.seguro == 1">
                          <td style="border: none">Reserva reembolsable:</td>
                          <td class="text-right" style="border: none">
                            <v-text>
                              ${{ $store.state.protectionValue.toLocaleString() }}
                            </v-text>
                          </td>
                        </tr>

                        <tr>
                          <td style="
                            border-top: 1px solid;
                            border-bottom: 1px solid;
                            border-color: #cac5cb;
                          ">
                            <v-text class="font-weight-medium onBackground--text">
                              Precio Total:
                            </v-text>
                          </td>
                          <td class="text-right" style="
                            border-top: 1px solid;
                            border-bottom: 1px solid;
                            border-color: #cac5cb;
                          ">
                            <v-text class="onBackground--text subtitle-1">
                              ${{ $store.state.totalValue.toLocaleString() }}
                            </v-text>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <!--      <a class="btn btn-info" style="color: white;  "
                      @click="enviaraEvento()"><v-icon>shopping_cart</v-icon>&nbsp;
                      SEGUIR
                      COMPRANDO</a>

                    &nbsp;&nbsp;
                    <v-chip v-if="evento.venta_linea == 1 && evento.status == 1" @click="clearCantBoleta">
                      <v-icon center color="#907b16">remove_shopping_cart</v-icon>
                      <b>&nbsp;VACIAR CARRITO</b>
                    </v-chip> -->
                  </v-col>
                </div>
                <div class="col-md-3 col-lg-3 col-sm-3" v-if="evento.seguro == 0"></div>

              </v-sheet>



              <!-- Botones de Acciones -->
              <v-row v-if="$vuetify.breakpoint.mdAndUp">
                <v-col cols="12" class="text-center">
                  <v-btn color="primary" height="44px" block rounded
                    v-if="evento.venta_linea == 1 && evento.status == 1" @click="pagar()">
                    Confirmar y pagar
                  </v-btn>
                  <v-btn v-if="evento.venta_linea == 1 && evento.status == 1" @click="clearCantBoleta()" class="mt-3"
                    color="outline" outlined height="44px" block rounded>
                    <v-icon center></v-icon>&nbsp;Cancelar
                  </v-btn>
                </v-col>

                <!-- Terminos y condiciones -->
                <v-col class="p-3 d-flex justify-content-start">
                  <v-text>
                    Al hacer clic en Confirmar y pagar aceptas
                    <router-link target="_blank" v-model="acceptTyC" :to="{ name: 'terminoscondiciones' }">Términos y
                      condiciones</router-link>
                    y
                    <router-link v-model="acceptTD" :to="{ name: 'politicatratamiento' }" target="_blank">Tratamiento de
                      datos personales</router-link>
                  </v-text>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <!-- Botones de Acciones -->
          <v-row v-if="$vuetify.breakpoint.smAndDown">
            <v-col cols="12" class="text-center">
              <v-btn color="primary" height="44px" block rounded v-if="evento.venta_linea == 1 && evento.status == 1"
                @click="pagar()">
                Confirmar y pagar
              </v-btn>
              <v-btn v-if="evento.venta_linea == 1 && evento.status == 1" @click="clearCantBoleta()" class="mt-3"
                color="outline" outlined height="44px" block rounded>
                <v-icon center></v-icon>&nbsp;Cancelar
              </v-btn>
            </v-col>

            <!-- Terminos y condiciones -->
            <v-col class="p-3 d-flex justify-content-start">
              <v-text>
                Al hacer clic en Confirmar y pagar aceptas
                <router-link target="_blank" v-model="acceptTyC" :to="{ name: 'terminoscondiciones' }">Términos y
                  condiciones</router-link>
                y
                <router-link v-model="acceptTD" :to="{ name: 'politicatratamiento' }" target="_blank">Tratamiento de
                  datos personales</router-link>
              </v-text>
            </v-col>
          </v-row>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import TipoEventos from './fragments/TipoEventos.vue';
import Carousel from './fragments/Carousel.vue';
import BoletasxLocalidad from './utils/BoletasxLocalidad.vue';
import TablaEvento from './Templates/Evento/TablaEvento';

import PgWidgetLoaded from './PgWidgetLoaded.vue';
import Participantes from './utils/Participantes.vue';
import moment from 'moment';
import { faSleigh } from '@fortawesome/free-solid-svg-icons';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/es';
import 'flatpickr/dist/themes/material_blue.css';
moment.locale('es');

export default {
  components: {
    TipoEventos,
    Carousel,
    BoletasxLocalidad,
    TablaEvento,
    flatPickr,
    PgWidgetLoaded,
    Participantes,
  },
  data() {
    return {

      radioGroup: '',
      creditCardNumber: '',
      creditCardName: '',
      creditCardExpiry: '',
      cvv: '',
      pseAccountNumber: '',
      pseBankName: '',
      numeropuestoscompra: '',
      cargarWidgetSeguro: 0,
      valortotalcompra: 0,
      protectionValue: 0,
      fechaevento: '',
      cartsubtotal: 0,
      cartotal: 0,
      cartseguro: 0,
      type: 'month',
      start: new Date(),
      end: new Date(),
      typeOptions: [
        { text: 'Day', value: 'day' },
        { text: '4 Day', value: '4day' },
        { text: 'Week', value: 'week' },
        { text: 'Month', value: 'month' },
        { text: 'Custom Daily', value: 'custom-daily' },
        { text: 'Custom Weekly', value: 'custom-weekly' },
      ],
      selectedDate: new Date(),
      seleccionado: null,
      enabledDates: [],
      fechaselectedDate: '',
      seleccionadohora: '',
      menu: false,
      acceptTyC: false,
      acceptTD: false,
      dialogotablaprecios: false,
      dataCompare: null,
      tab: 'general',
      tabpreventa: 0,
      modalSelectEntregaBoletas: false,
      entregaBoletas: 'digital',
      keyBoletasxLocalidad: 0,
      mostrarmapa: true,
      modalVisible: false,
      horario: [],
      flatpickrStyle: {
        width: '500px',
        height: '70px',
      },
      funcionseleccionada: 0,
      ventas: [
        {
          localidad: 'palco F.A.M.E',
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: 'palco F.A.M.E',
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: 'palco F.A.M.E',
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: 'palco F.A.M.E',
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: 'palco F.A.M.E',
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: 'palco F.A.M.E',
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
        {
          localidad: 'palco F.A.M.E',
          aforo: 32,
          precio: 456000,
          servicio: 200000,
        },
      ],
      keyPuntoventas: '',
      headersPuntoventa: [
        {
          text: 'Nombre Comercial',
          align: 'left',
          value: 'punto_ventum.nombre_razon',
        },
        {
          text: 'Dirección',
          value: 'punto_ventum.direccion',
        },
        {
          text: 'Ciudad',
          value: 'punto_ventum.id_ciudad',
        },
        {
          text: 'Zona/Region',
          value: 'punto_ventum.zona',
        },
        {
          text: 'Telefono',
          value: 'punto_ventum.telefono',
        },
        {
          text: 'Responsable',
          value: 'punto_ventum.responsable',
        },
      ],
      rowperpageitems: [5, 10, 25, { text: 'Todos', value: -1 }],
      idLocalidad: '',
      dialogmapasientos: false,
      elhtml2: '',
      monedaSelectShop: null,
      activeModalAsientos: false,
    };
  },
  watch: {
    // evento(){
    //   this.$store.dispatch('auditorio_mapeado/listLocalidadesAuditorio_mapeado',this.evento.id_auditorio_mapeado);
    // },
    async evento() {
      this.$store.commit('evento/setImagenesEvento', null);
      if (this.evento) {
        this.$store.dispatch('evento/listPreventasEvento', this.evento.id);
        this.$store.dispatch(
          'auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado',
          this.evento.id
        );
        await this.$store.dispatch('evento/changeMonedaShopEvento', {
          codigo_moneda: this.monedaSelectShopEvento,
          evento_id: this.evento.id,
        });
        this.$store.dispatch('evento/getCondicionesEvento', this.evento.id);
        this.$store.dispatch('evento/listPreventasEvento', this.evento.id);
        this.$store.dispatch('evento/getpuntoventasEvento', this.evento.id);
        this.$store.dispatch(
          'auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado',
          this.evento.id
        );
        this.mostrarmapa = true;
        if (this.evento.id_tipo_evento == 7) {
          this.mostrarmapa = false;
        }

        if (
          this.monedaSelectShopEvento === null &&
          this.evento.monedas_evento.length > 0
        ) {
          this.$store.commit(
            'evento/changeMonedaShopEvento',
            this.evento.monedas_evento[0].codigo_moneda
          );
          this.monedaSelectShop = this.monedaSelectShopEvento;
        } else {
          this.monedaSelectShop = this.monedaSelectShopEvento;
        }
        this.$store.dispatch('evento/getImagenesEvento', this.evento.id);
        $('html, body').animate({ scrollTop: $('body').offset().top }, 1);
        this.activeModalAsientos = false;
        if (this.evento && this.evento.slug != this.$route.params.evento) {
          this.$store.dispatch(
            'auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado',
            this.evento.id
          );
          this.$store.dispatch(
            'auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado',
            this.evento.id
          );
        }
        if (this.idLocalidad && this.evento.localidades_evento) {
          let element = this.evento.localidades_evento.find(
            (e) => e.id_localidad == parseInt(this.idLocalidad)
          );
          if (!element) {
            this.idLocalidad = '';
          }
        }
        setTimeout(() => {
          this.activeModalAsientos = true;
        }, 500);
        this.keyBoletasxLocalidad += 1;
      }
    },

    totalValorBoletasCarrito() {
      //  this.refrescarvalorwidget();
    },

    dialogmapasientos() {
      setTimeout(() => {
        var self = this;
        $('.area_mapeadaAuditorio2').append(
          $('<textarea />')
            .html(
              this.evento.auditorio_mapeado.area_mapeada.replaceAll(
                '<br>',
                ''
              )
            )
            .text()
            .replaceAll('&nbsp;', '')
        );
        $('.maparea').click(function (e) {
          e.preventDefault();
          var texthref = e.currentTarget.href;
          var arrayhref = texthref.split('/');
          self.getPuestos(arrayhref[arrayhref.length - 1], null);
          window.location.hash = 'boletas';
          self.dialogmapasientos = false;
        });
      }, 200);
    },
    '$route.params.evento': function (from, to) {
      this.onMounted();
      window.scroll(0, 0);
    },
  },
  async beforeCreate() {
    this.$store.dispatch('ciudad/listCiudades');
    await this.$store.dispatch('auditorio/listAuditorios');
    //await this.$store.dispatch("evento/getEvento", this.$route.params.evento);
    await this.$store.dispatch('evento/listEventosStatus', {
      page: 1,
      status: 1,
    });

    // this.$store.dispatch('auditorio_mapeado/listLocalidadesAuditorio_mapeado',this.$store.getters['evento/evento'].id_auditorio_mapeado);
    // this.$store.dispatch('auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado', this.$route.params.evento);
    // this.$store.dispatch('auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado', this.$route.params.evento);

    if (this.evento && this.evento.status != 1 && this.evento.status != 3) {
      this.$router.push({ path: '/' });
    }

    if (this.userAuth.id_rol != null && this.userAuth.id_rol == 5) {
      this.$router.push({ name: 'misEventos' });
    }
  },
  async mounted() {
    $('html, body').animate({ scrollTop: $('body').offset().top }, 1);
    await this.onMounted();
    self = this;
    window.setInterval(() => {
      self.validateDateTimeSale();
    }, 3000);
    // this.mapasientos(true);

    this.$nextTick(() => {
      setTimeout(() => {
        // Obtener la estructura desde localStorage
        const estadoGuardado = localStorage.getItem('estadoVuex');

        // Asegurarse de que haya un estado guardado y establecerlo en Vuex si existe
        if (estadoGuardado) {
          this.$store.replaceState(JSON.parse(estadoGuardado));
        }
        //  console.log( this.$store.state);
        this.refrescarvalorwidget();
      }, 500);
    });

    if (this.evento.id_tipo_evento == 7) {
      this.traerFechasFunciones();
    }
  },
  beforeUpdate() {
    // document.title = `${this.evento ? this.evento.nombre : 'Evento Ticketshop'} - TicketShop`;

    if (this.evento.id == 258) {
      document.title =
        'Venta de Boletas Concierto Marco Antonio Solís en Cali - TicketShop';
    } else {
      document.title = `${this.evento ? this.evento.nombre : 'Evento Ticketshop'
        } - TicketShop`;
    }

    if (this.idLocalidad != '') {
      document.getElementsByClassName(
        'cont-mapa-asientos'
      )[0].style.backgroundImage = '';
    }
  },
  updated() {
    /*if (this.elhtml2!="")
  {
    $('#btnPayU2').submit();
  }*/
  },
  methods: {
    formatProductName(nombre) {
      // Ajustamos la expresión regular para aceptar "Palco" o "Boleta" con más flexibilidad.
      let regex = /(Palco|Boleta)\s+\w+\s+(\d+)/;
      let match = nombre.match(regex);

      if (match) {
        // Modificamos el número encontrado, precediéndolo con un "#" y devolvemos el formato deseado.
        return match[0].replace(/(\d+)/, '#$1');
      } else {
        // Si no hay coincidencia, devolvemos el nombre original sin cambios.
        return nombre;
      }
    },

    miFuncion(selectedDates, dateStr, instance) {
      this.$store.dispatch('carrito/getfuncioneshora', {
        id_evento: this.evento.id,
        fecha: dateStr,
      });
      this.fechaselectedDate = dateStr;
    },

    async traerFechasFunciones() {
      this.$store.state.fechafunciones = null;
      await this.$store.dispatch('carrito/getfechafunciones', {
        id: this.evento.id,
      });
    },
    async traerfuncionalcargar() {
      //  console.log( this.$store.state.fechafunciones);
      /*  this.enabledDates = this.$store.state.fechafunciones;
       this.$store.dispatch("carrito/getfuncioneshora", {
         id_evento:  this.evento.id,
         fecha:   this.$store.state.fechafunciones[0],
      }); */
    },

    async cargarPreciosFunciones(id) {
      this.modalVisible = true;
      this.$store.state.funcioneslocalidades = null;
      this.funcionseleccionada = id;
      await this.$store.dispatch('carrito/getfuncioneslocalidades', {
        id: id,
      });
    },

    cerrarModalFunciones() {
      this.modalVisible = false;
    },
    ejecutarGetPuestos(id) {
      var self = this;
      self.getPuestos(id, null);
      window.location.hash = 'boletas';
      this.modalVisible = false;
    },
    async handleDateClick(date) {
      await this.$store.dispatch('carrito/getfuncioneshora', {
        id_evento: this.evento.id,
        fecha: this.selectedDate,
      });
    },
    async onMounted() {
      var self = this;
      await this.$store.dispatch(
        'evento/getEvento',
        this.$route.params.evento
      );

      //$('.carousel').height($('.cont-desc-evento').height());

      var self = this;
      setTimeout(() => {
        self.activeModalAsientos = true;
      }, 500);
      setTimeout(() => {
        $('.area_mapeadaAuditorio2').append(
          $('<textarea />')
            .html(
              self.$store.getters['evento/evento'].auditorio_mapeado
                .area_mapeada
            )
            .text()
            .replace('&nbsp;', '')
        );
        $('.maparea').click(function (e) {
          e.preventDefault();
          var texthref = e.currentTarget.href;
          var arrayhref = texthref.split('/');
          self.getPuestos(arrayhref[arrayhref.length - 1], null);
          window.location.hash = 'boletas';
          //$("html, body").animate({ scrollTop: $('#boletas').offset().top }, 1);
          self.dialogmapasientos = false;
          //$("html, body").animate({ scrollTop: 700 }, 1000);
        });
      }, 900);
    },
    enviaraEvento() {
      window.location.href = '/eventos/' + this.evento.slug;
    },
    async clearCantBoleta() {
      this.$store.state.carrito.descuentocupon = 0;
      this.$store.state.carrito.cuponestado = 0;
      this.$store.state.carrito.vservicio = 0;
      this.$store.state.carrito.cupon = '';
      this.$store.state.carrito.cuponok = false;
      this.$store.state.funcioneshora = [];
      localStorage.removeItem('boletasReservadasPV');
      localStorage.removeItem('palcosReservadosPV')
      localStorage.removeItem("validacionpalco");
      localStorage.removeItem('mantenerParticipantes');

      if (
        this.preciosBoletasCarrito &&
        this.preciosBoletasCarrito.length > 0
      ) {
        var lasBoletas = [];
        var losPalcos = [];

        for (
          var i = 0;
          i < this.listLocalidadesEventoAuditorio_mapeado.length;
          i++
        ) {
          if (
            this.cantBoleta[
            this.listLocalidadesEventoAuditorio_mapeado[i].id
            ] != null
          ) {
            if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
              losPalcos = losPalcos.concat(
                this.cantBoleta[
                this.listLocalidadesEventoAuditorio_mapeado[i].id
                ]
              );
            } else {
              lasBoletas = lasBoletas.concat(
                this.cantBoleta[
                this.listLocalidadesEventoAuditorio_mapeado[i].id
                ]
              );
            }
            this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]
              .length;
          }
        }

        await this.$store.dispatch('carrito/setNullReservas', {
          boletas: lasBoletas,
          palcos: losPalcos,
        });

        this.$store.dispatch('evento/clearCantBoleta');
        await this.refrescarvalorwidget();
        //this.$router.push('/eventos/' + this.evento.slug);
      } else {
        swal('Error!', 'El carrito esta vacio!', 'error');
      }

      /*if (this.preciosBoletasCarrito && this.preciosBoletasCarrito.length > 0) {
      console.log('ingrese al precio');
      
      var lasBoletas = [];
      var losPalcos = [];


      lasBoletas = JSON.parse(localStorage.getItem('newboletasclear'));
      losPalcos = JSON.parse(localStorage.getItem('newpalcosclear'));

      await this.$store.dispatch("carrito/setNullReservas", {
        boletas: lasBoletas,
        palcos: losPalcos,
      });

      localStorage.removeItem('newboletasclear');
      localStorage.removeItem('newpalcosclear');
      localStorage.removeItem('funcionselected');
      localStorage.removeItem('boletasReservadasPV');
      localStorage.removeItem('mantenerParticipantes');

      this.idLocalidad = "";
      this.$store.dispatch("evento/clearCantBoleta");
      this.$store.dispatch("carrito/setNullPreciosBoletasCarrito");
      this.$store.dispatch("carrito/dateTimeSaleStart", null);
      this.$store.dispatch("carrito/dateTimeSaleEnd", null);
      swal("Exito!", "El carrito se vacio correctamente.", "success");
      this.$store.state.showModalFinalizarCompra = false;
      localStorage.removeItem('estadoVuex');
      //this.$router.push('/eventos/' + this.evento.slug);
    } else {
      console.log('no tengo precio');
      
      var lasBoletas = [];
      var losPalcos = [];
      this.idLocalidad = "";
      this.$store.dispatch("evento/clearCantBoleta");
      swal("Informacion", "El carrito esta vacio.", "info");
      localStorage.removeItem('funcionselected');
      localStorage.removeItem('boletasReservadasPV');
      localStorage.removeItem('mantenerParticipantes');
      localStorage.removeItem('estadoVuex');
      this.$store.state.showModalFinalizarCompra = false;
      //this.$router.push('/eventos/' + this.evento.slug);
    }*/
    },
    dateTimeToDate(datetime) {
      if (datetime != null && datetime != '') {
        return moment(datetime).format('YYYY/MM/DD');
      } else {
        return '';
      }
    },
    formatFecha(fecha) {
      if (fecha != null && fecha != '') {
        return moment(fecha).format('MMMM, DD YYYY');
      } else {
        return '';
      }
    },
    formatTime(time) {
      if (time != null && time != '') {
        return moment(time, 'HH:mm:ss').format('LT');
      } else {
        return '';
      }
    },
    formatDatetimeString(datetime) {
      if (datetime != null && datetime != '') {
        return moment(datetime).format(
          'dddd Do [de] MMMM [del] YYYY [a las] h:m a'
        );
      } else {
        return '';
      }
    },
    formatNumber(number) {
      return new Intl.NumberFormat('es-CO', {
        minimumFractionDigits: 0,
      }).format(number);
    },
    getCiudad(id) {
      let filter_ciudad = this.ciudades.filter((ciudad) => ciudad.id == id);
      if (filter_ciudad[0] == '' || filter_ciudad[0] == null) {
        return '';
      } else {
        return filter_ciudad[0].descripcion;
      }
    },
    getPuestos(id, localidad) {
      if (this.evento && this.evento.status === 3) {
        return false;
      }

      this.idLocalidad = id;
      if (localidad === null) {
        var localidadFilter = null;
        if (
          this.listLocalidadesEventoAuditorio_mapeado &&
          this.listLocalidadesEventoAuditorio_mapeado.length > 0
        ) {
          localidadFilter =
            this.listLocalidadesEventoAuditorio_mapeado.filter(
              (item) => item.id == id
            );
          this.$store.dispatch(
            'carrito/localidadSelectCarrito',
            localidadFilter
          );
        }
      } else {
        this.$store.dispatch('carrito/localidadSelectCarrito', localidad);
      }
    },
    getAuditorio(id) {
      let filter_auditorio = [];
      if (this.auditorios) {
        filter_auditorio = this.auditorios.filter(
          (auditorio) => auditorio.id == id
        );
      }
      if (filter_auditorio[0] == '' || filter_auditorio[0] == null) {
        return '';
      } else {
        return filter_auditorio[0].nombre;
      }
    },
    async mapasientos(mostrar) {
      if (mostrar) {
        await this.$store.commit('evento/setEvento', this.evento);
      }
      this.dialogmapasientos = mostrar;
    },

    async refrescarvalorwidget() {
      var cupon = 'NA';
      if (
        this.currentRoute != 'evento' ||
        this.evento.fechaValidaInicioInternet
      ) {
        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$store.state.modalLogin = true;
        } else {
          if (this.$store.state.carrito.cantBoletaTotal == 0) {
            this.$store.state.resumenFinalizarCompra = null;
            swal('Carrito Vacio!', 'No ha reservado boletas!', 'success');
            localStorage.removeItem('estadoVuex');
            this.$router.push('/eventos/' + this.evento.slug);
          } else {
            if (
              this.entregaBoletas != null &&
              this.entregaBoletas != undefined
            ) {
              var lasBoletas = [];
              var losPalcos = [];

              for (
                var i = 0;
                i < this.listLocalidadesEventoAuditorio_mapeado.length;
                i++
              ) {
                if (
                  this.$store.state.carrito.cantBoleta[
                  this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ] != null
                ) {
                  if (
                    this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1
                  ) {
                    losPalcos = losPalcos.concat(
                      this.$store.state.carrito.cantBoleta[
                      this.listLocalidadesEventoAuditorio_mapeado[i].id
                      ]
                    );
                  } else {
                    lasBoletas = lasBoletas.concat(
                      this.$store.state.carrito.cantBoleta[
                      this.listLocalidadesEventoAuditorio_mapeado[i].id
                      ]
                    );
                  }
                  this.$store.state.carrito.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ].length;
                }
              }
              if (lasBoletas != [] || losPalcos != []) {
                if (this.$store.state.carrito.cupon != null) {
                  cupon = this.$store.state.carrito.cupon;
                }

                //Eliminar Duplicidad ID
                const duplicidadPalcos = new Set(losPalcos);
                let resultDupliPalcos = [...duplicidadPalcos];

                const duplicidadBoletas = new Set(lasBoletas);
                let resultDupliBoletas = [...duplicidadBoletas];

                await this.$store
                  .dispatch('detalle_Boletas_Finalizarcompra', {
                    palcos:
                      resultDupliPalcos.length > 0 ? resultDupliPalcos : '',
                    boletas:
                      resultDupliBoletas.length > 0 ? resultDupliBoletas : '',
                    cupon: cupon.length > 2 ? cupon : 'NA',
                    funcionseleccionada:
                      localStorage.getItem('funcionselected'),
                    protectionValue: this.$store.state.protectionValue,
                    pgwidget: this.$store.state.pgwidget,
                    productId: this.$store.state.productId,
                    sold: this.$store.state.sold,
                  })
                  .then(() => {
                    if (this.$store.state.errorDetalleCompra) {
                      swal(
                        'Parece que algo salio mal!',
                        'Intentalo nuevamente',
                        'error'
                      );
                      return '';
                    } else {
                      //console.log(this.$store.state.resumenFinalizarCompra);
                      this.$store.state.showModalFinalizarCompra = true;

                      var cantidadDinero =
                        this.$store.state.resumenFinalizarCompra.totalVenta;
                      cantidadDinero = cantidadDinero
                        .replace(/[^0-9,]/g, '')
                        .replace(',', '.');

                      this.numeropuestoscompra =
                        this.$store.state.resumenFinalizarCompra.numeropuestoscompra;

                      this.valortotalcompra =
                        this.$store.state.resumenFinalizarCompra.totalVenta;
                      this.cartsubtotal = parseFloat(cantidadDinero);

                      this.$store.state.totalValue =
                        parseFloat(cantidadDinero);
                    }
                  });
              } else if (lasBoletas == [] && losPalcos == []) {
                swal('Carrito Vacio!', 'No ha reservado boletas!', 'success');
                localStorage.removeItem('estadoVuex');
                this.$router.push('/eventos/' + this.evento.slug);
                return '';
              }
            } else {
              this.modalSelectEntregaBoletas = true;
            }
          }
        }
      } else {
        swal(
          'Error!',
          'Ventas en linea disponible despues de ' +
          this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          ),
          'error'
        );
      }
    },

    async pagar() {
      var cupon = 'NA';

      // console.log(localStorage.getItem('estadoVuex'))

      let lsBoletasReservadas = localStorage.getItem('boletasReservadasPV');
      let lsFormParticipantes = localStorage.getItem('mantenerParticipantes');
      let arrBoletasReservadas = JSON.parse(lsBoletasReservadas);
      let arrFormParticipantes = JSON.parse(lsFormParticipantes);

      //Validar datos de participantes
      if (this.evento.id_tipo_evento == 8) {
        if (lsFormParticipantes === null) {
          swal(
            '¡Datos Incompletos!',
            'El formulario del participante está vacío.',
            'warning'
          );
          return;
        }

        let cantidadParticipantes = 0;

        for (let i = 0; i < arrBoletasReservadas.length; i++) {
          let boleta = arrBoletasReservadas[i];
          let participante = arrFormParticipantes.find(
            (boletas) => boletas.id_boleta === boleta
          );

          if (participante === undefined) {
            swal(
              '¡Datos Incompletos!',
              'Por favor verifique el formulario de los participantes.',
              'warning'
            );
            return;
          }

          if (participante.nombre === '') {
            swal(
              '¡Datos Incompletos!',
              'Nombre Completo está vacío, por favor verifique el formulario del participante.',
              'warning'
            );
            return;
          }

          // if(participante.email === "" || participante.email === null) {
          //   swal("¡Datos Incompletos!", "Correo Electrónico está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.documento === "" || participante.documento === null) {
          //   swal("¡Datos Incompletos!", "Documento está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.fecha_nacimiento === ""  || participante.fecha_nacimiento === null) {
          //   swal("¡Datos Incompletos!", "Fecha Nacimiento está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.talla_camiseta === "" || participante.talla_camiseta === null) {
          //   swal("¡Datos Incompletos!", "Talla de Camiseta está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.eps === "" || participante.eps === null) {
          //   swal("¡Datos Incompletos!", "EPS está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.rh === "" || participante.rh === null) {
          //   swal("¡Datos Incompletos!", "RH está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.contacto === "" || participante.contacto === null) {
          //   swal("¡Datos Incompletos!", "Contacto de Emergencia está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.num_contacto === "" || participante.num_contacto === null) {
          //   swal("¡Datos Incompletos!", "Número de Contacto está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // if(participante.parentesco === "" || participante.parentesco === null) {
          //   swal("¡Datos Incompletos!", "Parentesco está vacío, por favor verifique el formulario del participante.", "warning");
          //   return;
          // }

          // switch (participante) {
          //     case 'nombre':
          //         swal("¡Datos Incompletos!", "Nombre Completo está vacío, por favor verifique el formulario del participante.", "warning");
          //         return;
          //     case 'email':
          //         swal("¡Datos Incompletos!", "Correo Electrónico está vacío, por favor verifique el formulario del participante.", "warning");
          //         return;
          // }

          cantidadParticipantes++;
        }

        if (cantidadParticipantes < arrFormParticipantes.length) {
          swal(
            '¡Datos Incompletos!',
            'Por favor verifique el formulario de los participantes.' +
            cantidadParticipantes +
            ' len: ' +
            arrFormParticipantes.length,
            'warning'
          );
          return;
        }
      }

      if (
        this.evento.id_tipo_evento == 7 &&
        localStorage.getItem('funcionselected') == 0
      ) {
        swal(
          'Funcion no Selecciona!',
          'Algo salió mal. Limpiar el carrito e iniciar de nuevo!',
          'success'
        );
      } else {
        if (
          this.currentRoute != 'evento' ||
          this.evento.fechaValidaInicioInternet
        ) {
          if (this.$store.getters['user/dataUserLogged'].nombre == null) {
            this.$store.state.modalLogin = true;
            //swal("Error!", "Debe Iniciar Sesión!", "error");
          } else {
            if (this.$store.state.carrito.cantBoletaTotal == 0) {
              swal('Carrito Vacio!', 'No ha reservado boletas!', 'success');
              localStorage.removeItem('estadoVuex');
              this.$router.push('/eventos/' + this.evento.slug);
            } else {
              if (
                this.entregaBoletas != null &&
                this.entregaBoletas != undefined
              ) {
                var lasBoletas = [];
                var losPalcos = [];

                for (
                  var i = 0;
                  i < this.listLocalidadesEventoAuditorio_mapeado.length;
                  i++
                ) {
                  if (
                    this.$store.state.carrito.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                    ] != null
                  ) {
                    if (
                      this.listLocalidadesEventoAuditorio_mapeado[i].palco ==
                      1
                    ) {
                      losPalcos = losPalcos.concat(
                        this.$store.state.carrito.cantBoleta[
                        this.listLocalidadesEventoAuditorio_mapeado[i].id
                        ]
                      );
                    } else {
                      lasBoletas = lasBoletas.concat(
                        this.$store.state.carrito.cantBoleta[
                        this.listLocalidadesEventoAuditorio_mapeado[i].id
                        ]
                      );
                    }
                    this.$store.state.carrito.cantBoleta[
                      this.listLocalidadesEventoAuditorio_mapeado[i].id
                    ].length;
                  }
                }
                if (lasBoletas != [] && losPalcos == []) {
                  if (this.$store.state.carrito.cupon != null) {
                    cupon = this.$store.state.carrito.cupon;
                  }
                  await this.$store.dispatch('obtener_refventa', {
                    boletas: lasBoletas,
                    moneda: this.$store.getters['evento/monedaSelectShop'],
                    email: this.$store.getters['user/dataUserLogged'].email,
                    nombre: this.$store.getters['user/dataUserLogged'].nombre,
                    identificacion:
                      this.$store.getters['user/dataUserLogged']
                        .identificacion,
                    tipo_identificacion:
                      this.$store.getters['user/dataUserLogged']
                        .tipo_identificacion,
                    entrega_boletas: this.entregaBoletas,
                    cupon: cupon.length > 2 ? cupon : 'NA',
                    funcionseleccionada:
                      localStorage.getItem('funcionselected'),
                    protectionValue: this.$store.state.protectionValue,
                    pgwidget: this.$store.state.pgwidget,
                    productId: this.$store.state.productId,
                    sold: this.$store.state.sold,
                    participantes: localStorage.getItem(
                      'mantenerParticipantes'
                    ),
                  });
                  this.$store.state.carrito.descuentocupon = 0;
                  this.$store.state.carrito.cuponestado = 0;
                  this.$store.state.carrito.vservicio = 0;
                  this.$store.state.carrito.cupon = '';
                  this.$store.state.carrito.cuponok = false;
                  localStorage.removeItem('funcionselected');
                  localStorage.removeItem('estadoVuex');
                  localStorage.removeItem('mantenerParticipantes');
                  localStorage.removeItem('newboletasclear');
                  localStorage.removeItem('boletasReservadasPV');
                } else if (lasBoletas == [] && losPalcos != []) {
                  if (this.$store.state.carrito.cupon != null) {
                    cupon = this.$store.state.carrito.cupon;
                  }
                  await this.$store.dispatch('obtener_refventa', {
                    palcos: losPalcos,
                    moneda: this.$store.getters['evento/monedaSelectShop'],
                    email: this.$store.getters['user/dataUserLogged'].email,
                    nombre: this.$store.getters['user/dataUserLogged'].nombre,
                    identificacion:
                      this.$store.getters['user/dataUserLogged']
                        .identificacion,
                    tipo_identificacion:
                      this.$store.getters['user/dataUserLogged']
                        .tipo_identificacion,
                    entrega_boletas: this.entregaBoletas,
                    cupon: cupon.length > 2 ? cupon : 'NA',
                    funcionseleccionada:
                      localStorage.getItem('funcionselected'),
                    protectionValue: this.$store.state.protectionValue,
                    pgwidget: this.$store.state.pgwidget,
                    productId: this.$store.state.productId,
                    sold: this.$store.state.sold,
                    participantes: localStorage.getItem(
                      'mantenerParticipantes'
                    ),
                  });
                  this.$store.state.carrito.descuentocupon = 0;
                  this.$store.state.carrito.cuponestado = 0;
                  this.$store.state.carrito.vservicio = 0;
                  this.$store.state.carrito.cupon = '';
                  this.$store.state.carrito.cuponok = false;
                  localStorage.removeItem('funcionselected');
                  localStorage.removeItem('estadoVuex');
                  localStorage.removeItem('mantenerParticipantes');
                  localStorage.removeItem('newboletasclear');
                  localStorage.removeItem('boletasReservadasPV');
                } else if (lasBoletas != [] && losPalcos != []) {
                  if (this.$store.state.carrito.cupon != null) {
                    cupon = this.$store.state.carrito.cupon;
                  }
                  await this.$store.dispatch('obtener_refventa', {
                    boletas: lasBoletas,
                    palcos: losPalcos,
                    moneda: this.$store.getters['evento/monedaSelectShop'],
                    email: this.$store.getters['user/dataUserLogged'].email,
                    nombre: this.$store.getters['user/dataUserLogged'].nombre,
                    identificacion:
                      this.$store.getters['user/dataUserLogged']
                        .identificacion,
                    tipo_identificacion:
                      this.$store.getters['user/dataUserLogged']
                        .tipo_identificacion,
                    entrega_boletas: this.entregaBoletas,
                    cupon: cupon.length > 2 ? cupon : 'NA',
                    funcionseleccionada:
                      localStorage.getItem('funcionselected'),
                    participantes: localStorage.getItem(
                      'mantenerParticipantes'
                    ),
                    protectionValue: this.$store.state.protectionValue,
                    pgwidget: this.$store.state.pgwidget,
                    productId: this.$store.state.productId,
                    sold: this.$store.state.sold,
                  });
                  this.$store.state.carrito.descuentocupon = 0;
                  this.$store.state.carrito.cuponestado = 0;
                  this.$store.state.carrito.vservicio = 0;
                  this.$store.state.carrito.cupon = '';
                  this.$store.state.carrito.cuponok = false;
                  this.$store.state.funcioneshora = [];
                  localStorage.removeItem('estadoVuex');
                  localStorage.removeItem('mantenerParticipantes');
                  localStorage.removeItem('newboletasclear');
                  localStorage.removeItem('boletasReservadasPV');
                  localStorage.removeItem('palcosReservadosPV')
                } else if (lasBoletas == [] && losPalcos == []) {
                  swal(
                    'Carrito Vacio!',
                    'No ha reservado boletas!',
                    'success'
                  );
                  localStorage.removeItem('funcionselected');
                  localStorage.removeItem('estadoVuex');
                  this.$router.push('/eventos/' + this.evento.slug);
                  return '';
                }

                if (this.$store.getters['get_init_point'] != null) {
                  this.idLocalidad = '';
                  await this.$store.dispatch('evento/clearCantBoleta');
                  await this.$store.dispatch(
                    'carrito/setNullPreciosBoletasCarrito'
                  );
                  await this.$store.dispatch(
                    'carrito/dateTimeSaleStart',
                    null
                  );
                  await this.$store.dispatch('carrito/dateTimeSaleEnd', null);
                  window.location.href =
                    this.$store.getters['get_init_point'];
                }
              } else {
                this.modalSelectEntregaBoletas = true;
              }

              //var refventa = this.$store.getters['obtener_refventa'].refVenta;

              //var total = this.$store.getters['obtener_refventa'].precio_total;

              //var moneda = this.listLocalidadesEventoAuditorio_mapeado[0].localidad_evento[0].codigo_moneda;
              //var moneda = this.$store.getters['evento/monedaSelectShop'];

              //await this.$store.dispatch('generarsha',{
              //  moneda: moneda,
              //  refventa: refventa
              //});

              /* var usuario = this.$store.getters['user/dataUserLogged'];
            var info_pago = this.$store.getters['sha'];

            this.elhtml2 = '<input type="image" src="https://paymentsbakery.co/gateway/images/payments-bakery.png" border="0" alt="payments-bakery">\
            <input name="usuarioId" type="hidden" value="'+info_pago.usuarioId+'">\
            <input name="firma" type="hidden" value="'+info_pago.firma_codificada+'">\
            <input name="descripcion" type="hidden" value="'+'descripcion'+'">\
            <!-- Descripcon de la Venta Productos-->\
            <input name="refVenta" type="hidden" value="'+info_pago.refVenta+'">\
            <!--  Referencia de Venta Numero de 6 digitos -->\
            <input name="valor" type="hidden" value="'+total+'">\
            <!--  Valor de la Compra -->\
            <input name="moneda" type="hidden" value="'+moneda+'">\
            <!--  Moneda de la Compra:  PERU:  604 soles y 840 dolares. COLOMBIA COP -->\
            <input name="lang" type="hidden" value="SP">\
            <!--  lenguage   SP - Español   EN - Ingles-->\
            <input name="extra1" type="hidden" value="'+'datosCompra'+'">\
            <input name="extra2" type="hidden" value="'+'datosCompra'+'">\
            <input name="extra3" type="hidden" value="'+'datosCompra'+'">\
            <input name="url_respuesta" type="hidden" value="'+info_pago.URLRespuesta+'">\
            <input name="url_confirmacion" type="hidden" value="'+info_pago.URLConfirma+'">\
            <input name="emailComprador" type="hidden" value="'+usuario.email+'"/>\
            <input name="Comprador" type="hidden" value="'+usuario.nombre+'"  />\
            <!--  Nombre Comprador -->\
            <input name="documentoIdentificacion" type="hidden" value="'+'10628701'+'"  />\
            <!--  Documento de Identidad Comprador -->\
            <input name="Test" type="hidden" value="1"/>';
            */
            }
          }
        } else {
          swal(
            'Error!',
            'Ventas en linea disponible despues de ' +
            this.formatDatetimeString(
              this.evento.fecha_inicio_venta_internet_formateada
            ),
            'error'
          );
        }
      }
    },
    getPreventa(index) {
      switch (index) {
        case -1:
          this.accion = 'Aprobar';
          break;
        case 1:
          this.accion = 'Aprobar';
          break;
        case 2:
          this.accion = 'Rechazar';
          break;
        case 4:
          this.accion = 'Aprobar Con Modificaciones';
          break;
      }
    },
    getLocalidadDescuento(localidad, preventa) {
      var total =
        parseFloat(
          eval(
            'localidad.localidad_evento[0].precio_venta' +
            this.indexMonedaSelectShopEvento
          )
        ) +
        parseFloat(
          eval(
            'localidad.localidad_evento[0].precio_servicio' +
            this.indexMonedaSelectShopEvento
          )
        );

      if (preventa) {
        if (
          preventa.id_localidad == localidad.id ||
          preventa.id_tribuna == localidad.id_tribuna ||
          preventa.id_evento == this.evento.id
        ) {
          if (preventa.precios_monedas) {
            var precioMonedaActual = preventa.precios_monedas.filter(
              (item) => item.codigo_moneda === this.monedaSelectShopEvento
            )[0];

            if (precioMonedaActual) {
              if (precioMonedaActual.descuento_fijo_servicio) {
                total =
                  parseFloat(total) -
                  parseFloat(precioMonedaActual.descuento_fijo_servicio);
              } else if (preventa.porcentaje_descuento_servicio) {
                total =
                  parseFloat(total) -
                  (parseFloat(
                    eval(
                      'localidad.localidad_evento[0].precio_servicio' +
                      this.indexMonedaSelectShopEvento
                    )
                  ) *
                    parseFloat(preventa.porcentaje_descuento_servicio)) /
                  100;
              }
              if (precioMonedaActual.descuento_fijo_precio) {
                total =
                  parseFloat(total) -
                  parseFloat(precioMonedaActual.descuento_fijo_precio);
              } else if (preventa.porcentaje_descuento_precio) {
                total =
                  parseFloat(total) -
                  (parseFloat(
                    eval(
                      'localidad.localidad_evento[0].precio_venta' +
                      this.indexMonedaSelectShopEvento
                    )
                  ) *
                    parseFloat(preventa.porcentaje_descuento_precio)) /
                  100;
              }
            }
          }
        }
      }
      return total + (total * localidad.localidad_evento[0].impuesto) / 100 <=
        0
        ? 0
        : this.formatNumber(
          total + (total * localidad.localidad_evento[0].impuesto) / 100
        );
    },
    getPrecioServicioLocalidad(localidad) {
      var precio_servicio = parseFloat(
        eval(
          'localidad.localidad_evento[0].precio_servicio' +
          this.indexMonedaSelectShopEvento
        )
      );

      return this.formatNumber(precio_servicio);
    },
    getPrecioVentaLocalidad(localidad) {
      var precio_servicio = parseFloat(
        eval(
          localidad.localidad_evento[0].precio_venta +
          this.indexMonedaSelectShopEvento
        )
      );
      return this.formatNumber(precio_servicio);
    },
    changeMonedaShopEvento() {
      this.$store.dispatch('evento/changeMonedaShopEvento', {
        codigo_moneda: this.monedaSelectShop,
        evento_id: this.evento.id,
      });
      this.$router.go(this.$router.currentRoute);
    },
    concatTextMoneda(item) {
      return `(${item.moneda.simbolo}) ${item.moneda.descripcion}`;
    },
    validateDateTimeSale() {
      let fecha = new Date();

      if (this.dateTimeSaleStart != null && this.dateTimeSaleEnd != null) {
        // if(this.getBrowser.includes('Safari')) {
        //   swal("Safari Mode", "Modo Safari", "info")
        // }

        if (
          Date.parse(fecha) >= Date.parse(this.dateTimeSaleStart) &&
          Date.parse(fecha) <= Date.parse(this.dateTimeSaleEnd)
        ) {
        } else {
          if (this.dateTimeSaleStart) {
            localStorage.removeItem('mantenerParticipantes');
            localStorage.removeItem('newboletasclear');
            localStorage.removeItem('boletasReservadasPV');
            localStorage.removeItem('palcosReservadosPV')
            localStorage.removeItem("validacionpalco");
            this.$store.state.showModalFinalizarCompra = false;
            this.$store.state.resumenFinalizarCompra = null;
            this.idLocalidad = '';
            this.$store.dispatch('carrito/dateTimeSaleStart', null);
            this.$store.dispatch('carrito/dateTimeSaleEnd', null);
            this.$store.dispatch('carrito/setNullPreciosBoletasCarrito');
            this.$store.dispatch('evento/clearCantBoleta');
            swal('Informacion', 'El carrito esta vacio.', 'info');
            localStorage.removeItem('estadoVuex');
            this.$store.state.showModalFinalizarCompra = false;
            this.$router.push('/eventos/' + this.evento.slug);
          }
        }
      }
    },
    getBrowser() {
      var ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null)
          return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M = M[2]
        ? [M[1], M[2]]
        : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    },
    formatFechaClasic(fecha) {
      if (fecha != null && fecha != '') {
        return moment(fecha).format('YYYY-MM-DD');
      } else {
        return '';
      }
    },
  },
  computed: {
    usuario() {
      return this.$store.getters['user/dataUserLogged'];
    },
    flatpickrConfig() {
      return {
        inline: true,
        locale: 'es',
        enable: this.$store.state.fechafunciones,
        onChange: this.miFuncion,
      };
    },
    pagos() {
      if (this.evento && this.evento.status == 1) {
        return true;
      } else {
        return false;
      }
    },
    hoy() {
      return moment().format('Y-MM-DD');
    },
    cantBoleta() {
      return this.$store.getters['evento/cantBoleta'];
    },
    cantBoletaTotal() {
      return this.$store.getters['evento/cantBoletaTotal'];
    },
    ciudades() {
      return this.$store.getters['ciudad/listCiudades'];
    },
    evento() {
      return this.$store.getters['evento/evento'];
    },
    condicionesEvento() {
      return this.$store.getters['evento/condicionesEvento'];
    },
    preventasEvento() {
      return this.$store.getters['evento/listPreventasEvento'];
    },
    showEventosDestacados() {
      return this.$store.getters['evento/listEventosDestacados'];
    },
    eventosDestacados() {
      return this.showEventosDestacados.slice(0, 4);
    },
    imagenesEvento() {
      return this.$store.getters['evento/imagenesEvento'];
    },
    userAuth() {
      return this.$store.getters['user/dataUserLogged'];
    },
    puntoventasEvento() {
      return this.$store.getters['evento/puntoventasEvento'];
    },
    // listLocalidadesAuditorio_mapeado() {
    //   return this.$store.getters['auditorio_mapeado/listLocalidadesAuditorio_mapeado'];
    // },
    listLocalidadesEventoAuditorio_mapeado() {
      return this.$store.getters[
        'auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado'
      ];
    },
    mapaauditorio() {
      if (
        this.evento.auditorio.latitud != '' &&
        this.evento.auditorio.longitud != ''
      ) {
        return (
          'https://maps.google.com/?ll=' +
          this.evento.auditorio.latitud +
          ',' +
          this.evento.auditorio.longitud +
          '&z=14&t=m&output=embed'
        );
      } else {
        return '';
      }
    },
    auditorios() {
      return this.$store.getters['auditorio/listAuditorios'];
    },
    // boletas(){
    //   return this.$store.getters['carrito/listBoletas'];
    // },
    imagenesEventoCarousel() {
      let imagenesEventoCarouselShow = [];
      if (this.imagenesEvento) {
        imagenesEventoCarouselShow = this.imagenesEvento.filter((imagen) => {
          return imagen.imagen.nombre.includes('banner');
        });
      }
      return imagenesEventoCarouselShow;
    },
    monedaSelectShopEvento() {
      return this.$store.getters['evento/monedaSelectShop'];
    },
    indexMonedaSelectShopEvento() {
      if (
        this.evento.monedas_evento &&
        this.evento.monedas_evento.length > 0
      ) {
        var index = this.evento.monedas_evento.findIndex(
          (moneda) => moneda.codigo_moneda === this.monedaSelectShopEvento
        );
        if (index === 0) {
          return '';
        } else {
          return index + 1;
        }
      }
    },
    simboloMoneda() {
      if (
        this.indexMonedaSelectShopEvento === '' ||
        this.indexMonedaSelectShopEvento === 0
      ) {
        return this.evento
          ? this.evento.monedas_evento[0].moneda.simbolo
          : '';
      } else {
        return this.evento
          ? this.evento.monedas_evento[this.indexMonedaSelectShopEvento - 1]
          : ''.moneda.simbolo;
      }
    },
    preciosBoletasCarrito() {
      return this.$store.getters['carrito/preciosBoletasCarrito'];
    },
    totalValorBoletasCarrito() {
      var preciosBoletasCarritoMonedaActual = this.$store.getters[
        'carrito/preciosBoletasCarrito'
      ].filter((item) => item.codigo_moneda == this.monedaSelectShopEvento);
      if (
        preciosBoletasCarritoMonedaActual &&
        preciosBoletasCarritoMonedaActual.length > 0
      ) {
        var total = 0;
        for (
          var i = preciosBoletasCarritoMonedaActual.length - 1;
          i >= 0;
          i--
        ) {
          total += preciosBoletasCarritoMonedaActual[i].precio;
        }
        return this.formatNumber(total);
      } else {
        return 0;
      }
    },
    localidadSelectCarrito() {
      return this.$store.getters['carrito/localidadSelectCarrito'];
    },
    countBoletas() {
      return this.$store.getters['carrito/countBoletas'];
      /* var lasBoletas = [];
    var losPalcos = [];

    for (var i = 0; i < this.listLocalidadesEventoAuditorio_mapeado.length; i++) {
      if (this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id] != null) {
        if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
          losPalcos = losPalcos.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
        } else {
          lasBoletas = lasBoletas.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
        }
        this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id].length;
      }
    }

    return lasBoletas.length; */
    },
    countPalcos() {
      return this.$store.getters['carrito/countPalcos'];
      /* var lasBoletas = [];
    var losPalcos = [];

    for (var i = 0; i < this.listLocalidadesEventoAuditorio_mapeado.length; i++) {
      if (this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id] != null) {
        if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
          losPalcos = losPalcos.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
        } else {
          lasBoletas = lasBoletas.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
        }
        this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id].length;
      }
    }

    return losPalcos.length;*/
    },
    dateTimeSaleStart() {
      return this.$store.getters['carrito/dateTimeSaleStart'];
    },
    dateTimeSaleEnd() {
      return this.$store.getters['carrito/dateTimeSaleEnd'];
    },
    listLocalidadesEventoAuditorioGeneral_mapeado() {
      const listadoVentaNormal =
        this.$store.getters[
        'auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado'
        ];
      const listadoPreventas =
        this.$store.getters['evento/listPreventasEvento'];
      let listadoFinalPreventas = [];

      for (let i = 0; i < listadoVentaNormal.length; i++) {
        for (let j = 0; j < listadoPreventas.length; j++) {
          if (
            (listadoVentaNormal[i].id_tribuna ==
              listadoPreventas[j].id_tribuna &&
              !listadoFinalPreventas.includes(listadoVentaNormal)) ||
            (listadoVentaNormal[i].id_evento ==
              listadoPreventas[j].id_evento &&
              !listadoFinalPreventas.includes(listadoVentaNormal)) ||
            (listadoVentaNormal[i].id_tribuna ==
              listadoPreventas[j].id_tribuna &&
              !listadoFinalPreventas.includes(listadoVentaNormal))
          ) {
            var tempData = listadoVentaNormal[i];
            tempData.fecha_inicio = listadoPreventas[j].fecha_inicio;
            tempData.fecha_fin = listadoPreventas[j].fecha_fin;
            tempData.total = this.getLocalidadDescuento(
              tempData,
              listadoPreventas[j]
            );
            if (listadoPreventas[j].porcentaje_descuento_precio) {
              tempData.localidad_evento[0].precio_venta =
                (tempData.localidad_evento[0].precio_venta * 100) /
                listadoPreventas[j].porcentaje_descuento_precio;
            } else if (listadoPreventas[j].porcentaje_descuento_servicio) {
              tempData.localidad_evento[0].precio_venta =
                (tempData.localidad_evento[0].precio_venta * 100) /
                listadoPreventas[j].porcentaje_descuento_servicio;
            } else if (
              listadoPreventas[j].precios_monedas[0].descuento_fijo_precio
            ) {
              tempData.localidad_evento[0].precio_venta =
                tempData.localidad_evento[0].precio_venta -
                listadoPreventas[j].precios_monedas[0].descuento_fijo_precio;
            } else if (
              listadoPreventas[j].precios_monedas[0].descuento_fijo_servicio
            ) {
              tempData.localidad_evento[0].precio_venta =
                tempData.localidad_evento[0].precio_venta -
                listadoPreventas[j].precios_monedas[0]
                  .descuento_fijo_servicio;
            }
            listadoFinalPreventas.push(tempData);
          }
        }
      }
      return listadoFinalPreventas;
    },
  },
};
</script>
<style scoped>
.v-main-complete {
  height: 100vh;
  overflow-y: auto;

}

.info-evento-scroll {
  max-height: none;
  overflow-y: visible;
  padding-right: 0;
}

.resumen-compra-sticky {
  position: static;
  /* o relative si prefieres */
  top: auto;
  z-index: auto;
}




@media (min-width: 960px) {
  .info-evento-scroll {
    max-height: 95vh;
    overflow-y: auto;
    padding-right: 8px;

  }

  .resumen-compra-sticky {
    position: sticky;
    top: 0;
    z-index: 3;
    background: inherit;
    padding: 16px;
  }
}
</style>
<style>
.cabin {
  font-family: 'Cabin', sans-serif;
}

.list-condiciones-evento li {
  text-transform: capitalize;
}

.carousel {
  height: auto !important;
}

.color-slide-table {
  color: black !important;
  margin-left: auto;
  margin-right: auto;
}

.skeleton-banner-principal-evento {
  height: 100%;
  aspect-ratio: 880/448;
}

.img-skeleton .v-skeleton-loader__image {
  height: 500px;
}

.skeleton-banner-principal-evento .v-skeleton-loader .v-skeleton-loader__image,
.skeleton-banner-principal-evento .v-skeleton-loader {
  height: 100%;
}

.container-modal-resumen {
  background-color: white;
  padding: 1.5rem 1rem;
}

@media (max-width: 768px) {
  .container-modal-resumen {
    padding: 1rem 0.5rem;
  }
}
</style>
